<p-floatlabel class="w-full" variant="on">
  <p-select
    (onChange)="onLanguageChange($event)"
    [formControl]="activeControl()"
    [invalid]="activeControl().invalid && activeControl().touched"
    [options]="languages"
    appendTo="body"
    class="w-40"
    fluid
    optionLabel="name"
    optionValue="code"

  >
    <ng-template #value>
      @for (lang of languages; track lang.code) {
        @if (lang.code === activeControl().value) {
          <div class="flex items-center gap-2">
            <img alt="" height="30" ngSrc="{{ lang.flagUrl }}" width="30"/>
            <span>{{ lang.name }}</span>
          </div>
        }
      }
    </ng-template>

    <ng-template #item let-language>
      <div class="flex items-center gap-2">
        <img alt="" height="30" ngSrc="{{ language.flagUrl }}" width="30"/>
        <span>{{ language.name }}</span>
      </div>
    </ng-template>

  </p-select>
  <label>
    {{ 'app.language' | translate }}
    @if (isRequired()) {
      <span class="text-red-500">*</span>
    }
  </label>
</p-floatlabel>
@if (activeControl().invalid && activeControl().touched && activeControl().hasError('required')) {
  <p-message severity="error" size="small" variant="simple">{{ 'error.required' | translate }}</p-message>
}
